module.exports = __webpack_public_path__ + "img/trine-beder-john-1.85c42517.png";